import React, { IframeHTMLAttributes, useMemo, useState } from 'react';
import './style.scss';
import { Portal } from '@material-ui/core';
// @ts-expect-error react-rnd 7.3 ships no types
import Rnd from 'react-rnd';
import Icon from '../Utils/NewIcon';

type Props = {
  onRequestClose: () => void;
} & IframeHTMLAttributes<unknown>;

const IFrameModal = (props: Props) => {
  const [interacting, setInteracting] = useState(false);

  const hostname = useMemo(() => {
    if (props.src) {
      return new URL(props.src).hostname;
    }
    return '';
  }, [props.src]);

  return (
    <Portal
      container={() =>
        document.querySelector('.staff-modal-container') || document.querySelector('body')
      }
    >
      <Rnd
        default={{ x: 100, y: 60, width: 400, height: 800 }}
        minWidth={280}
        minHeight={200}
        // react-rnd 7.3 has no "window" bounds (v8+); unknown selectors clamp dragging to (0,0)
        bounds="body"
        // react-rnd 7.3 forwards this verbatim as a CSS selector, so the dot is required
        dragHandleClassName=".header"
        onDragStart={() => setInteracting(true)}
        onDragStop={() => setInteracting(false)}
        onResizeStart={() => setInteracting(true)}
        onResizeStop={() => setInteracting(false)}
      >
        <div className={`iframe-modal${interacting ? ' interacting' : ''}`}>
          <div className="header">
            <div className="lhs"></div>
            <div className="center">{hostname}</div>
            <div className="rhs">
              <Icon src="xmark" onClick={props.onRequestClose} />
            </div>
          </div>
          <iframe {...props} />
        </div>
      </Rnd>
    </Portal>
  );
};

export default IFrameModal;
